module.exports = __webpack_public_path__ + "img/df4792b.png";